/*globals $*/
'use strict';

// Include base block
var Block = require('../libs/block');
var FormsetManager = require('../libs/django-formset-manager');

// Create new block
module.exports = Block.extend({
    template: '#order-editor',

    /**
     * Basic Block-initialization
     */
    init: function () {
        this.formsetManager = new FormsetManager($('#order-form'), {
            prefix: 'items',
            eventsHook: this._eventHooks.bind(this)
        });
    },

    _eventHooks: function (element) {
        element.find('.manuf-select').change(this._onManufacturerChange.bind(this));
        element.find('.type-select').change(this._onParcelTypeChange.bind(this));
        element.find('.quantity').on('keyup click change', this._onQuantityChange.bind(this));
        element.find('.formsetItemDelete').click(this._onDelelteButtonClick.bind(this));

        this._populateExistingLoadingTimeAttributes();
        this._updateTotalDurationDisplay();
    },

    /** @return {HTMLFormElement[]} */
    _getForms: function() {
        var element = this.$el[0];
        return element.querySelectorAll('.row.order-item-form:not(.hidden)');
    },

    _populateExistingLoadingTimeAttributes: function() {
        var forms = this._getForms();
        for(var i = 0; i < forms.length; i++)
        {   
            var form = forms[i];
            /** @type {HTMLSelectElement} */
            var manufacturerSelect = form.querySelector('.manuf-select');
            /** @type {HTMLSelectElement} */
            var typeSelect = form.querySelector('.type-select');
            /** @type {HTMLInputElement} **/
            var quantityInput  = form.querySelector('.quantity');

            var selectedManufacturer = parseInt(manufacturerSelect.options[manufacturerSelect.selectedIndex].value);
            
            var template = document.getElementById('types-manuf-' + selectedManufacturer);

            if (template)
            {
                var templateElement = document.createElement('div');
                templateElement.innerHTML = template.innerHTML;

                for(var j = 0; j < typeSelect.options.length; j++)
                {
                    var option = typeSelect.options[j];
                    if (option.value.length > 0)
                    {
                        var selector = '[value="' + option.value + '"]';
                        option.setAttribute(
                            'data-loading-time', 
                            templateElement.querySelector(selector).getAttribute('data-loading-time')
                        );
                    }
                }
            }
        }
    },

    _updateTotalDurationDisplay: function() {
        var forms = this._getForms();
        var totalMinutes = 0;
        var slotSize = parseInt(document.getElementById('order-form').getAttribute('data-calendar-slot-size-minutes'));

        for(var i = 0; i < forms.length; i++)
        {   
            var form = forms[i];

            /** @type {HTMLSelectElement} */
            var typeSelect = form.querySelector('.type-select');
            /** @type {HTMLInputElement} **/
            var quantityInput  = form.querySelector('.quantity');
            var quantityInputValue = quantityInput ? parseInt(quantityInput.value) : 1;
            
            if (typeSelect != null && quantityInputValue)
            {
                var value = parseInt((typeSelect.options[typeSelect.selectedIndex].getAttribute('data-loading-time'))) * quantityInputValue;
                totalMinutes += isNaN(value) ? 0 : value;
            }   
        }
        
        var totalMinutesRounded = totalMinutes + (totalMinutes % slotSize);
        
        var totalDuration = moment.duration(totalMinutes, 'minutes');
        var totalDurationRounded = moment.duration(totalMinutesRounded, 'minutes');

        // moment.js doesn't support formatting durations. https://github.com/moment/moment/issues/1048
        var formatDuration = function(d) {
            var formatNumber = function(n) {
                return n < 10 ? '0' + n.toString() : n;
            }

            return [formatNumber(d.hours()), 'h:',formatNumber(d.minutes()), 'm'].join('');
        }

        var totalMinutesElement = document.getElementById('totalMinutes');
        if (totalMinutesElement) {totalMinutesElement.innerHTML = formatDuration(totalDuration); }
        
        var totalMinutesRoundedElement = document.getElementById('totalMinutesRounded');
        if (totalMinutesRoundedElement) { totalMinutesRoundedElement.innerHTML = formatDuration(totalDurationRounded); }
    },

    _onManufacturerChange: function (event) {
        var manufSelect = $(event.target);
        var typeSelect = manufSelect.parents('.row:first').find('.type-select');
        
        // Copy type options from the template
        typeSelect.html($('#types-manuf-' + manufSelect.val()).html() || '<option value="">---------</option>');
        this._updateTotalDurationDisplay();
    },

    _onParcelTypeChange: function (event) {
        this._updateTotalDurationDisplay();
    },

    _onQuantityChange: function (event) {
        this._updateTotalDurationDisplay();

    },

    _onDelelteButtonClick: function (event) {
        this._updateTotalDurationDisplay();
    }
});
